import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import HtmlContentBlock from 'components/HtmlContentBlock';
import Collapsable from 'components/Collapsable';
import FirmSection from 'components/FirmSection';
import BasicButton from 'components/BasicButton';
import FirmAboutDescriptionSectionItem from './components/FirmAboutDescriptionSectionItem';

import './styles.css';

const FirmAboutDescriptionSection = props => {
  const {
    isEditMode = false,
    id,
    title,
    content,
    subBlocks,
    onEditBlock,
    onDeleteBlock,
    onAddDescriptionSubBlock,
    onEditSubBlock,
    onDeleteSubBlock,
  } = props;

  const [hasSubBlocks, cls] = useMemo(() => {
    const hasSubBlocks = subBlocks && subBlocks.length > 0;
    return [
      hasSubBlocks,
      hasSubBlocks
        ? 'firm-about-description-section_subsections'
        : 'firm-about-description-section_subsections firm-about-description-section_subsections--empty',
    ];
  }, [subBlocks]);

  const controls = isEditMode
    ? id
      ? [
          { caption: 'Edit', handler: onEditBlock },
          { caption: 'Delete', handler: onDeleteBlock },
        ]
      : [{ caption: 'Edit', handler: onEditBlock }]
    : null;

  return isEditMode ? (
    <FirmSection title={title} controls={controls}>
      <div className="firm-about__text">
        <HtmlContentBlock
          content={
            content || '<p>Please specify a description about your firm</p>'
          }
        />
      </div>
      <div className={cls}>
        <div className="firm-about-description-section">
          <ul className="firm-about-description-section__list">
            {subBlocks.map(b => (
              <FirmAboutDescriptionSectionItem
                item={b}
                key={b.FirmInfoBlockID}
                onEdit={onEditSubBlock}
                onDelete={onDeleteSubBlock}
              />
            ))}
          </ul>
          <div className="firm-about-description-section__buttons">
            <BasicButton
              btnWidth={100}
              btnHeight={35}
              btnFontSize="0.8571rem"
              btnFontWeight={600}
              btnText="Add"
              btnArrow={false}
              controlFunc={onAddDescriptionSubBlock}
            />
          </div>
        </div>
      </div>
    </FirmSection>
  ) : (
    (hasSubBlocks || content) && (
      <FirmSection title={title}>
        {content && (
          <div className="firm-about__text">
            <Collapsable
              btnHidden={
                content.length < 400 && content.split(/\r\n|\r|\n/).length <= 5
              }
              maskHidden={
                content.length < 400 && content.split(/\r\n|\r|\n/).length <= 5
              }
            >
              <HtmlContentBlock content={content} />
            </Collapsable>
          </div>
        )}
        <div className={cls}>
          <ul className="firm-about-description-section__list">
            {subBlocks.map(b => (
              <FirmAboutDescriptionSectionItem
                item={b}
                key={b.FirmInfoBlockID}
              />
            ))}
          </ul>
        </div>
      </FirmSection>
    )
  );
};

FirmAboutDescriptionSection.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  subBlocks: PropTypes.array,
  onEditBlock: PropTypes.func.isRequired,
  onDeleteBlock: PropTypes.func.isRequired,
  onAddDescriptionSubBlock: PropTypes.func.isRequired,
  onEditSubBlock: PropTypes.func.isRequired,
  onDeleteSubBlock: PropTypes.func.isRequired,
};

export default FirmAboutDescriptionSection;
